import script from "./PasswordInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordInput.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordInput.vue?vue&type=style&index=0&id=74c8747e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74c8747e"]])

export default __exports__